import { InputProps } from 'antd'

const toNullableNumber = (value?: string | number): number | null =>
  value !== void 0 ? Number(value) : null

const isOutOfBounds = (
  next: number,
  min: number | null,
  max: number | null,
): boolean => (min !== null && next < min) || (max !== null && next > max)

export const getStepValue = (
  direction: 'up' | 'down',
  props: Pick<InputProps, 'value' | 'step' | 'min' | 'max'>,
): number | null => {
  const current = Number(props.value) || 0
  const step = Number(props.step) || 1
  const min = toNullableNumber(props.min)
  const max = toNullableNumber(props.max)
  const next = direction === 'up' ? current + step : current - step

  return isOutOfBounds(next, min, max) ? null : next
}
